var disableMixin = {
	data: function () {
		return {
			disabledProps: false,
		};
	},
	methods: {
		addDisableMessage: function (disabledItem) {
			const vm = this;
			let mydiv = null;

			let text =
				vm.dimensionsUnavailableForCutSizeOptions ||
				'Fallback text - dimensionsUnavailableForCutSizeOptions needs adding to translations';

			if (disabledItem == 'standardSizes') {
				mydiv = document.querySelector('.js-custom-size-container');
				if (
					(document.querySelector('input#width') && document.querySelector('input#height')) ||
					document.querySelector('input#diameter')
				) {
					// disc or sheet
					text =
						vm.dimenensionsUnavailableForCutSizeOptionsDiscOrSheet ||
						'Fallback text - dimenensionsUnavailableForCutSizeOptionsDiscOrSheet needs adding to translations';
				} else if (document.querySelector('select#diameter')) {
					// rod or tube
					text =
						vm.dimensionsUnavailableForCutSizeOptionsRodOrTube ||
						'Fallback text - dimensionsUnavailableForCutSizeOptionsRodOrTube needs adding to translations';
				}
			} else {
				mydiv = document.getElementById(disabledItem);
			}

			if (mydiv) {
				var mycontent = document.createElement('p');
				var myicon = document.createElement('i');
				myicon.classList.add('material-icons', 'icon-30');
				myicon.appendChild(document.createTextNode('sd_card_alert'));
				mycontent.appendChild(myicon);
				mycontent.appendChild(document.createTextNode(text));
				mycontent.classList.add('disabled-error');

				setTimeout(function () {
					mydiv.appendChild(mycontent);
				}, 10);
			}
		},
		disableItems: function (disabledArray) {
			const vm = this;
			vm.removeDisabledItems();

			if (disabledArray) {
				disabledArray.forEach((disabledItem) => {
					vm.addDisableMessage(disabledItem);

					if (disabledItem == 'round-corners') {
						Object.keys(vm.product.roundedCorners).forEach((key) => {
							vm.product.roundedCorners[key] = 0;
						});
					}

					if (disabledItem == 'standardSizes') {
						const container = document.querySelector('.js-custom-size');
						if (container) {
							const selectors = container.querySelectorAll(
								'#width, #length, #height, #diameter, .js-select-unit'
							);
							setTimeout(function () {
								selectors.forEach(function (invalidField) {
									invalidField.disabled = true;
									invalidField.classList.add('disabled');
									invalidField.classList.remove('selected');
								});
							}, 10);
						}
					}

					if (disabledItem == 'drilled-holes') {
						vm.product.holes.distanceFromEdge = 0;
						vm.product.holes.holeSize = 0;

						const holes = document.querySelectorAll('.drill-hole-wrapper input[type=checkbox]');
						holes.forEach(function (hole) {
							hole.checked = false;
						});
						vm.product.placement = [];

						document.querySelector('.drill-box').classList.add('disabled');
					}

					const container = document.getElementById(disabledItem);
					if (container) {
						const selectors = container.querySelectorAll('.selector, .form-group, .custom-checkbox');
						selectors.forEach(function (invalidField) {
							if (invalidField.nodeName == 'DIV') {
								const selects = invalidField.querySelectorAll('select, input');
								selects.forEach(function (selectItem) {
									selectItem.disabled = true;
								});
							}
							invalidField.classList.add('disabled');
							invalidField.classList.remove('selected');
						});
					}
				});
			}
		},
		removeDisabledItems: function () {
			const vm = this;

			const disabledErrors = document.querySelectorAll('.disabled-error');
			disabledErrors.forEach(function (disabledError) {
				disabledError.remove();
			});

			if (vm.productRules) {
				vm.productRules.forEach((productRule) => {
					if (productRule.rule) {
						productRule.rule.disabled.forEach((disabledItem) => {
							if (disabledItem == 'standardSizes') {
								const standardContainer = document.querySelector('.js-custom-size');
								if (standardContainer) {
									const standardCSelectors = standardContainer.querySelectorAll(
										'#width, #length, #height, #diameter, .js-select-unit'
									);
									standardCSelectors.forEach(function (invalidField) {
										invalidField.disabled = false;
										invalidField.classList.remove('disabled');
									});
								}
							} else {
								const container = document.getElementById(disabledItem);
								if (container) {
									const selectors = container.querySelectorAll(
										'.selector, .form-group, .custom-checkbox'
									);
									selectors.forEach(function (invalidField) {
										if (invalidField.nodeName == 'DIV') {
											const selects = invalidField.querySelectorAll('select, input');
											selects.forEach(function (selectItem) {
												selectItem.disabled = false;
											});
										}
										invalidField.classList.remove('disabled');
									});

									if (disabledItem == 'drilled-holes') {
										document.querySelector('.drill-box').classList.remove('disabled');
									}
								}
							}
						});
					}
				});
			}
		},
		/**
		 * Evaluates and applies disabling rules for product properties based on dynamic conditions.
		 *
		 * This function checks a set of product rules to determine whether specific UI elements or
		 * product options should be disabled. Each rule defines conditional logic based on product
		 * dimensions (e.g., width, height) using operators like `>`, `<`, `>=`, etc.
		 *
		 * If all conditions in a rule are met, the corresponding elements are disabled via
		 * `disableItems()`. If no rules match, previously disabled items are re-enabled using
		 * `removeDisabledItems()`.
		 *
		 * @param {number|string} value - The current value triggering the check, typically a dimension input.
		 */
		checkDisabled: function (value) {
			const vm = this;
			vm.disabledProps = false;

			if (vm.productRules) {
				vm.productRules.forEach((productRule) => {
					if (productRule.rule) {
						var operators = {
							'>': function (a, b) {
								return a > b;
							},
							'<': function (a, b) {
								return a < b;
							},
							'<=': function (a, b) {
								return a <= b;
							},
							'>=': function (a, b) {
								return a >= b;
							},
							'=': function (a, b) {
								return a == b;
							},
						};

						if (productRule.rule) {
							let amountOfVariables = 0;
							let tempOfValidErrors = [];
							let tempListOfDisable = [];

							Object.keys(productRule.rule).forEach((innerRule) => {
								if (productRule.rule[innerRule]) {
									const propertyName = innerRule;
									const $innerRule = productRule.rule[innerRule];

									if (typeof $innerRule === 'object' && $innerRule.value) {
										amountOfVariables = amountOfVariables + 1;
										const operator = $innerRule.operator;
										let ruleValue = parseInt($innerRule.value);
										let numberValue = vm.product.dimensions[propertyName];

										if (operator) {
											if (operators[operator](numberValue, ruleValue)) {
												tempListOfDisable.push(productRule.rule.disabled);
												tempOfValidErrors.push($innerRule);
											}
										}
									}
								}
							});

							// if the number of errors equals the total amount of rules then add the errors to the page
							if (tempOfValidErrors.length === amountOfVariables) {
								tempListOfDisable.forEach((disableThisItem) => {
									vm.disableItems(disableThisItem);
								});
								vm.disabledProps = true;
							}
						}
					}
				});
			}

			if (!vm.disabledProps) {
				vm.removeDisabledItems();
			}
		},
	}
};
